import { render } from "./Devices2.vue?vue&type=template&id=11b9e808&scoped=true"
import script from "./Devices2.vue?vue&type=script&lang=js"
export * from "./Devices2.vue?vue&type=script&lang=js"

import "./Devices2.vue?vue&type=style&index=0&id=11b9e808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b9e808"]])

export default __exports__